import {wishlist} from "@otto-ec/nexus-registry/wishlist";
import {dispatchWishlistUpdateEvent} from "./WishlistSaveButtonV1Sync.logic.ts";

export class HeartState {
    readonly isOnWishlist: boolean;
    readonly triggeredByUser: boolean;
    readonly icon: "wishlist" | "wishlist-active" | "animated-wishlist-active-highlight";
    readonly ariaLabel: string;

    constructor(isOnWishlist: boolean, triggeredByUser: boolean = false, previouslyTriggeredByUser?: boolean) {
        this.isOnWishlist = isOnWishlist;
        this.triggeredByUser = triggeredByUser;

        /*                                                                                                    */
        /*                                                                                                          */
        /*                                             */
        const newActiveIconWhenOnWishlist = previouslyTriggeredByUser || triggeredByUser ? "animated-wishlist-active-highlight"  : "wishlist-active";

        this.icon = isOnWishlist
          ? newActiveIconWhenOnWishlist
          : "wishlist";
        this.ariaLabel = !isOnWishlist
            ? "Artikel merken"
            : triggeredByUser
                ? "Artikel vom Merkzettel entfernen"
                : "Artikel gemerkt. Vom Merkzettel entfernen?";
    }

    copy({
        isOnWishlist = this.isOnWishlist,
        triggeredByUser = this.triggeredByUser,
    }: {
        isOnWishlist?: boolean;
        triggeredByUser?: boolean;
    } = {}): HeartState {
        return new HeartState(isOnWishlist, triggeredByUser, this.triggeredByUser);
    }
}

export async function executeWishlistAction({
    heartState,
    variationId,
    qualified,
    source,
    setHeartState,
}: {
    heartState: HeartState;
    variationId: string;
    qualified: "true" | "false";
    source: string;
    setHeartState: (heartState: HeartState) => void;
}): Promise<void> {
    if (heartState.isOnWishlist) {
        const result = await wishlist.deleteItem(variationId, source, undefined, "Heart");
        if (result.success) {
            setHeartState(heartState.copy({isOnWishlist: false, triggeredByUser: true}));
            showDeleteSuccessSnackbar();
            dispatchWishlistUpdateEvent();
        } else {
            showErrorSnackbar();
        }
    } else {
        setHeartState(heartState.copy({isOnWishlist: true, triggeredByUser: true}));
        const result = await wishlist.addItem(variationId, qualified === "true", source);
        if (result.success) {
            showAddSuccessSnackbar();
            dispatchWishlistUpdateEvent();
        } else {
            setHeartState(heartState);
            showErrorSnackbar();
        }
    }
}

export function showAddSuccessSnackbar() {
    otto.components.snackbarV1.push("Gemerkt!", {
        actions: "<oc-link-v2 slot=\"actions\" variant=\"inverted\"><a href='/wishlist-view/' aria-label=\"Zum Merkzettel\">Zum Merkzettel</a></oc-link-v2>",
        classNames: "ofc-wishlist-save-button-v1-snackbar-success",
    });
}

export function showErrorSnackbar() {
    otto.components.snackbarV1.push(
        "Änderung an deinem Merkzettel leider nicht möglich. Bitte versuche es erneut.",
        {classNames: "ofc-wishlist-save-button-v1-snackbar-error"},
    );
}

export function showDeleteSuccessSnackbar() {
    otto.components.snackbarV1.push("Vom Merkzettel entfernt.", {
        classNames: "ofc-wishlist-save-button-v1-snackbar-success",
    });
}
